document.addEventListener('DOMContentLoaded', function() {
  // Crear overlay
  const overlay = document.createElement('div');
  overlay.id = 'size-guide-overlay';
  document.body.appendChild(overlay);

  // Crear drawer
  const drawer = document.createElement('div');
  drawer.id = 'size-guide-drawer';
  drawer.innerHTML = '<button id="size-guide-close">✕</button><div id="size-guide-content"></div>';
  document.body.appendChild(drawer);

  // Interceptar todos los enlaces de guía de tallas
  document.querySelectorAll('a[href*="guia-de-tallas"]').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      fetch(this.href)
        .then(r => r.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const content = doc.querySelector('.content-for-layout') || doc.querySelector('main') || doc.body;
          document.getElementById('size-guide-content').innerHTML = content.innerHTML;
          drawer.classList.add('open');
          overlay.classList.add('open');
        });
    });
  });

  // Cerrar drawer
  document.getElementById('size-guide-close').addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  function closeDrawer() {
    drawer.classList.remove('open');
    overlay.classList.remove('open');
  }
});
